import { inject, type InjectionKey } from 'vue'
import type { Company } from '@gat-ship/types'
import type { DeactivateCompanyModalParams } from '../modals/CompanyModalDeactivate.vue'
import type { ActivateCompanyModalParams } from '../modals/CompanyModalReactivate.vue'

export interface CompanyModalsContext {
  showAddCompany: () => void
  showEditCompany: (company: Company) => void
  showDeactivateCompany: (params: DeactivateCompanyModalParams) => void
  showReactivateCompany: (params: ActivateCompanyModalParams) => void
}

export const companyModalsKey = Symbol(
  'company-modals'
) as InjectionKey<CompanyModalsContext>

export function useCompanyModals() {
  return inject(companyModalsKey)
}
